import { FANDOM_CONTEXT_UPDATE } from "@identity/custom_events";

export const waitForTrackingContextReady = (container: Window = window) => {
  const check = () =>
    container.fandomContext?.tracking?.pvNumber &&
    container.fandomContext?.tracking?.pvNumberGlobal &&
    container.fandomContext?.tracking?.pvUID;

  return new Promise<void>((resolve) => {
    if (check()) {
      return resolve();
    }

    const listener = () => {
      if (check()) {
        container.removeEventListener(FANDOM_CONTEXT_UPDATE, listener);
        resolve();
      }
    };
    container.addEventListener(FANDOM_CONTEXT_UPDATE, listener);
  });
};
